import client from "../../api/client";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetMyPageBoardsResponse } from "../../api/board";

type TApiFetchBoardComment = {
  limit: number;
  page?: number;
  offset?: number;
};

export const fetchMyBoards = async ({
  limit,
  offset,
  page,
}: TApiFetchBoardComment): Promise<GetMyPageBoardsResponse> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : { headers: { Authorization: `` } };
  const query = {
    query: { limit, offset, page },
  };
  return await client()
    .myBoards.get({ ...query, ...authHeader })
    .then((res) => {
      return res.body;
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchMyBoards");
      return {
        status_code: status,
        message: message,
        data: [],
        total: 0,
      };
    });
};
